const state = {
    userAdmin:[],
    typeUserAdmin:[],
    typeUserAdminRol:[],
    loadingUser: false,
    userAdminidDetails:[],
    userAdminidDetailsCompany:[],
    genderAffiliated:[],
    searchAffiliates: [],
    userStatus: []
};

export default state;